import React, {useState, useEffect } from "react";
import axios from "axios";
import { Button, TextField, Typography, Container } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useTheme } from "@mui/material/styles";
import "../style/login.scss";

function ResetPasswordMail() {
  const theme = useTheme();
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const isDark = theme.palette.mode === "dark";

  useEffect(() => {
      const script = document.createElement("script")
      script.src = "https://www.google.com/recaptcha/api.js?render="+process.env.REACT_APP_RECAPTCHA_KEY
      script.addEventListener("submit", handleSubmit)
      document.body.appendChild(script)
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Récupérer le token reCAPTCHA
      const recaptchaToken = await new Promise((resolve, reject) => {
        window.grecaptcha.ready(() => {
          window.grecaptcha
            .execute(process.env.REACT_APP_RECAPTCHA_KEY, { action: "login" })
            .then(token => resolve(token))
            .catch(err => reject(err));
        });
      });
      const response = await axios.post(process.env.REACT_APP_DOMAIN_URL+"/passwordResetMail", {
        email,
        recaptchaToken
      });
      if (response.status === 200) {
        setSuccess("Mail de réinitialisation envoyé !");
      }
    } catch (error) {
      if (error.response && error.response.data) {
        setError(error.response.data.error || "Erreur de connexion au serveur");
      } else {
        setError("Erreur de connexion au serveur");
      }
    }
  };


  return (
    <Container component="main" maxWidth="xs" className="logContainer">
      <div className="logContainerChild">
        <LockOutlinedIcon sx={{ color: isDark ? 'white' : 'black', fontSize: 30 }} />
        <Typography component="h1" variant="h5">
          Envoyer le lien de réinitialisation
        </Typography>
        {error && <p className="error-message">{error}</p>}
        {success && <p style={{ color: "green" }}>{success}</p>}
        <form onSubmit={handleSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="email"
            label="Adresse email associée au compte"
            type="text"
            id="email"
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button type="submit" fullWidth variant="contained" color="primary" sx={{ mt: 3 }}>
            Modifier le mot de passe
          </Button>
        </form>
      </div>
    </Container>
  );
}

export default ResetPasswordMail;
